import pinia from '@/store';
import App from './App.vue';
import router from '@/router';
import 'amfe-flexible';
import 'vant/lib/index.css';
import '@/assets/font/font.css';
import '@/styles/index.less';
// import commonCss from '@/styles/index.less';
import Vconsole from 'vconsole';

if (
  import.meta.env.VITE_USER_NODE_ENV === 'test' ||
  import.meta.env.VITE_USER_NODE_ENV === 'development'
) {
  new Vconsole();
}

const app = createApp(App);

app.use(router);
app.use(pinia);

app.mount('#app');

// const styleEl = document.createElement('style');
// styleEl.textContent = commonCss;
// document.head.appendChild(styleEl);
